import { useIntl } from 'react-intl'
import { cameraApi } from '@/api/cameraApi'
import {
  FilterSelectAsync,
  FilterSelectAsyncProps
} from '@/components/ui-shared/Tables/FilterSelect/FilterSelectAsync'
import { cameraQueryKeys } from '@/queries/cameraQueries'
import { CameraListItem } from '@/types/camera'
import { PaginatedResponse } from '@/types/pagination'
import { MAX_ITEMS_WITHOUT_PAGINATION } from '@/utils/pagination'

const params = {
  limit: MAX_ITEMS_WITHOUT_PAGINATION,
  ordering: 'camera_name'
}

type CameraFilterProps = Pick<
  FilterSelectAsyncProps<CameraListItem, PaginatedResponse<CameraListItem[]>>,
  'value' | 'onChange'
>

export const CameraFilter = ({ value, onChange }: CameraFilterProps) => {
  const intl = useIntl()

  return (
    <FilterSelectAsync<CameraListItem, PaginatedResponse<CameraListItem[]>>
      width={220}
      value={value}
      queryFn={() => cameraApi.getCameraList(params)}
      queryKey={cameraQueryKeys.list(params)}
      selectFn={(data) => data.results}
      getOptionValue={(camera) => camera.camera_id}
      getOptionLabel={(camera) => camera.camera_name}
      placeholder={intl.formatMessage({
        id: 'deployments.list.filter.camera.placeholder'
      })}
      onChange={onChange}
    />
  )
}
